// extracted by mini-css-extract-plugin
export default {"about":"styles_about__99M3U","header":"styles_header__2701I","text":"styles_text__zwfrz"};